import type { Element } from '@/components/canvas/document/publicTypes';

export function composeContainerTransform(element: Element, extra?: string): string | undefined {
  const parts: string[] = [];
  if (element.layout.rotation) parts.push(`rotate(${element.layout.rotation}deg)`);
  if (element.layout.rotate3d?.z) parts.push(`rotateZ(${element.layout.rotate3d.z}deg)`);
  if (element.layout.rotate3d?.x) parts.push(`rotateX(${element.layout.rotate3d.x}deg)`);
  if (element.layout.rotate3d?.y) parts.push(`rotateY(${element.layout.rotate3d.y}deg)`);

  const sx = element.layout.flipX ? -1 : 1;
  const sy = element.layout.flipY ? -1 : 1;
  if (sx !== 1 || sy !== 1) parts.push(`scale(${sx}, ${sy})`);

  if (extra) parts.push(extra);
  return parts.length ? parts.join(' ') : undefined;
}

export function appendBlurFilter(base: string | undefined, blurPx: number | undefined): string | undefined {
  const blur = blurPx && blurPx > 0 ? `blur(${blurPx}px)` : '';
  if (base && blur) return `${base} ${blur}`;
  return base || blur || undefined;
}
